export var accent0 = '#00A83E';
export var accentHover0 = '#00752b';
export var accent1 = '#f05921';
export var accent2 = '#33b2c8';
export var accent3 = '#d63131';
export var accent4 = '#fbb03b';
export var black = '#000';
export var headerAccent = '#34414e';
export var calendarBlue = '#54c0e8';
export var calendarBlueHover = '#cbecf8';
export var focus = '#0099ff';
export var focusHover = '#007acc';
export var gray0 = '#212226';
export var gray1 = '#30333c';
export var gray2 = '#40414a';
export var gray3 = '#4f515c';
export var gray4 = '#5e6063';
export var gray5 = '#7f8194';
export var gray6 = '#a6a7b5';
export var gray7 = '#cccdd6';
export var gray8 = '#f4f4f6';
export var gray9 = '#f5f5f7';

export var gray15 = '#20272c';
export var gray30 = '#40484e';

export var white = '#fff';
//# sourceMappingURL=colors.js.map